import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import {
  ArchiveDetailsExtendedModel,
  ArchiveDetailsModel,
  ArchiveDetailsResponseModel,
  WbsArchiveReceivedModel,
  WbsChargeCodeDetailsModel,
  wbsChargeCodeRequestModel,
  WbsResponseModel,
  WbsWithArchiveDetailsModel,
} from '../../../../common/models/wbs-picker.model';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { CloseOutService } from '../../../../http/intake/close-out.service';
import { ProgressIndicatorService } from '../../../../common/services/progress-indicator.service';
import { IntakeConstant } from '../../../constants/intake.constant';
import { SwiftDetails } from '../../../../common/models/intake-submission-details-common-section.model';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionsObj } from '../../../../common/models/common-models';
import { selectOptionsArchive } from '../../../../common/constants/common-helper';
import {
  DarkTooltipOptions,
  SharedConstant,
} from '../../../../common/constants/shared.constant';
import { SpinnerOptions } from '@usitsdasdesign/dds-ng/spinner';
import { SpinnerThemes } from '@usitsdasdesign/dds-ng/shared';
@Component({
  selector: 'app-wbs-charge-code',
  templateUrl: './wbs-charge-code.component.html',
  styleUrl: './wbs-charge-code.component.less',
})
export class WbsChargeCodeComponent implements OnInit, OnDestroy {
  archiveNotListedMsg: string = IntakeConstant.ARCHIVE_NOT_LISTED;
  _EMPTY: string = SharedConstant.EMPTY_STRING;
  constructor(
    private readonly closeoutService: CloseOutService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly _cdr: ChangeDetectorRef
  ) {}
  @Input() wbsChargeCode: string | undefined = undefined;
  @Input() wbsDescription: string | undefined = undefined;
  @Input() dataSubmissionId: number | null = null;
  @Input() dataOpportunityId: string = this._EMPTY;
  @Input() set wbsPendingCheckbox(value: boolean) {
    this.pendingWBSCheckboxValue = value;
  }
  @Input() set archiveDetails(details: WbsArchiveReceivedModel | null) {
    if (!details || !details?.archiveName || !details?.archiveNumber) {
      this.fetchArchiveDropDownData();
    }
    this.showArchiveDropdown = false;

    if (
      !!details?.archiveNumber &&
      details?.archiveNumber !== IntakeConstant.ARCHIVE_NOT_LISTED
    ) {
      this.archive = details;
      this.archiveDescription =
        details?.archiveNumber + ' ' + details?.archiveName;
      this.selectedArchive = details?.archiveNumber;
    } else if (details?.archiveNumber === IntakeConstant.ARCHIVE_NOT_LISTED) {
      this.archiveDescription = details?.archiveDescription ?? undefined;
      this.selectedArchive = details.archiveNumber;
    } else {
      this.archiveDescription = undefined;
      this.showArchiveDropdown = true;
    }
  }
  @Input() swiftDetails: SwiftDetails | null = null;
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;

  @Output() wbsOrArchiveChange: EventEmitter<WbsWithArchiveDetailsModel> =
    new EventEmitter<WbsWithArchiveDetailsModel>();

  readonly #unsubscriber$: Subject<void> = new Subject<void>();
  readonly #wbsUnsubscriber$: Subject<void> = new Subject<void>();

  archive: WbsArchiveReceivedModel | null = null;
  showPendingWBSCheckbox: boolean = false;
  pendingWBSCheckboxValue: boolean = false;

  searchList: string[] = [];

  wbsAPIData: WbsChargeCodeDetailsModel[] = [];
  initialWBSAPIData: WbsChargeCodeDetailsModel[] = [];
  initialLoadWBSData: string[] = [];
  tempSelectedCode: string | undefined = undefined;

  archiveSelectOptions = selectOptionsArchive;
  selectedArchive: string | undefined = undefined;
  archiveDropdownList: SelectItemOptions[] = [];
  archiveAPIData!: ArchiveDetailsResponseModel;
  initialArchiveAPIData!: ArchiveDetailsResponseModel;
  archiveDescription: string | undefined = undefined;

  isFetchingWBSData: boolean = false;
  showWBSDropdown: boolean = false;
  showArchiveDropdown: boolean = false;
  isFetchingArchiveData: boolean = false;
  totalSearchResultLoaded: number = 0;
  searchWBSText: string = '';
  checkboxThemeColor: string = SharedConstant.THEME_GREEN;
  defaultForEmptyFields: string = SharedConstant.DEFAULT_FOR_EMPTY_FIELDS;

  pageNumber: number = 0;
  totalCount: number = 0;
  pageSize: number = SharedConstant.PAGE_SIZE_15;

  tooltipOptions = DarkTooltipOptions;
  spinnerOptions: SpinnerOptions = {
    theme: SpinnerThemes.gray,
    thickness: '0.188rem',
    size: '1.563rem',
    isInverse: false,
  };

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (
      !this.pendingWBSCheckboxValue &&
      !this.wbsChargeCode &&
      !target.closest('.intake-wbs-picker') &&
      !target.closest('.spinner-overlay')
    ) {
      this.wbsChargeCode = this.tempSelectedCode ?? undefined;
      this.showWBSDropdown = false;
      if (this.wbsChargeCode) {
        this.showPendingWBSCheckbox = false;
      }
      if (!this.selectedArchive) {
        this.showArchiveDropdown = true;
      }
    }
    if (this.showArchiveDropdown && !target.closest('.archive-select')) {
      if (this.selectedArchive) {
        this.showArchiveDropdown = false;
      }
    }
  }

  ngOnInit(): void {
    if (this.pendingWBSCheckboxValue) {
      this.showPendingWBSCheckbox = true;
    } else if (!this.wbsChargeCode) {
      this.isFetchingWBSData = true;
      this.fetchWbsChargeCode(0);
      this.showPendingWBSCheckbox = true;
    } else {
      this.showPendingWBSCheckbox = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['wbsChargeCode']) {
      this.tempSelectedCode = this.wbsChargeCode;
    }
  }

  editWBSChargeCode(): void {
    if (this.permissionObj['Intake_Submission_WBS_Enable']) {
      this.searchWBSText = '';
      this.wbsAPIData = this.initialWBSAPIData;
      this.searchList = this.initialLoadWBSData;
      this.tempSelectedCode = this.wbsChargeCode;
      this.wbsChargeCode = undefined;
      // If initialWBSAPIData is null, then API res is null
      // If initialWBSAPIData length is 0, haven't done api call yet.
      if (
        this.initialWBSAPIData !== null &&
        this.initialWBSAPIData.length === 0
      ) {
        this.isFetchingWBSData = true;
        this.#wbsUnsubscriber$.next();
        this.fetchWbsChargeCode(1);
      }

      this.showPendingWBSCheckbox = true;
      this.showArchiveDropdown = false;
      this.showWBSDropdown = false;
    }
  }

  // 0 -> initial data, 1 -> edit, 2 -> search, 3 -> onscroll
  fetchWbsChargeCode(callFrom: number): void {
    if (callFrom !== 3) {
      this.searchList = [];
    }

    const requestBody = this.createRequestBody();
    this.closeoutService
      .getWbsChargeCodes(requestBody)
      .pipe(takeUntil(this.#wbsUnsubscriber$))
      .subscribe({
        next: (response: WbsResponseModel) => {
          if (response) {
            this.totalCount = response.totalCount;
            if (callFrom === 3) {
              this.wbsAPIData = [
                ...this.wbsAPIData,
                ...response.wbsChargeCodeDetails,
              ];
            } else {
              this.wbsAPIData = response.wbsChargeCodeDetails;
            }

            this.searchList = [
              ...this.searchList,
              ...(response.wbsChargeCodeDetails?.map(
                (wbs) => wbs.wbsChargeCode
              ) ?? []),
            ];

            if (
              callFrom === 0 ||
              (callFrom === 1 && this.initialLoadWBSData?.length === 0)
            ) {
              this.wbsAPIData = response.wbsChargeCodeDetails;
              this.initialWBSAPIData = response.wbsChargeCodeDetails;
              this.initialLoadWBSData = this.searchList;
            }

            if (
              !this.pendingWBSCheckboxValue &&
              this.searchList.length === 1 &&
              callFrom === 0
            ) {
              this.wbsChargeCode = this.searchList[0];

              this.onWbsChargeCodeSelect(this.wbsChargeCode);
            }

            this.totalSearchResultLoaded = this.searchList.length;
            this.isFetchingWBSData = false;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.isFetchingWBSData = false;
          console.error('error', error);
        },
      });
  }

  onWbsChargeCodeSelect(item: string): void {
    const selectedWBSCode: WbsChargeCodeDetailsModel | undefined =
      this.wbsAPIData?.find(
        (wbs: WbsChargeCodeDetailsModel) => wbs.wbsChargeCode === item
      );

    if (selectedWBSCode) {
      this.wbsDescription = selectedWBSCode?.wbsDescription;
      this.wbsChargeCode = selectedWBSCode?.wbsChargeCode;
      this.showPendingWBSCheckbox = false;
      this.updateWbsValues();

      this.selectedArchive = undefined;
      this.showArchiveDropdown = false;
      this.archiveDescription = undefined;
      this.fetchArchiveDropDownData();
    }
    if (!this.pendingWBSCheckboxValue) {
      this.showArchiveDropdown = true; // TODO: If we are waiting for api call then should set this there.
    }
  }

  onWBSSearchTextChange(event: string): void {
    this.showWBSDropdown = true;
    this.isFetchingWBSData = false;
    this.searchWBSText = event;
    this.pageNumber = 0;
    this.searchList = [];

    if (event?.length >= SharedConstant.TEXT_MIN_LENGTH_3) {
      this.isFetchingWBSData = true;
      this.#wbsUnsubscriber$.next();
      this.fetchWbsChargeCode(2);
    } else if (event.length === 0) {
      this.wbsAPIData = this.initialWBSAPIData;
      this.searchList = this.initialLoadWBSData;
      this.#wbsUnsubscriber$.next();
      this.isFetchingWBSData = false;
      this.progressIndicator.hide();
    }
  }

  wbsFieldCleared(): void {
    this.showWBSDropdown = true;
    this.isFetchingWBSData = false;
    this.searchWBSText = '';
    this.pageNumber = 0;
    this.wbsAPIData = this.initialWBSAPIData;
    this.searchList = this.initialLoadWBSData;
  }

  fetchMoreWbsResult(): void {
    if (this.totalSearchResultLoaded < this.totalCount) {
      this.pageNumber++;
      this.isFetchingWBSData = true;
      this.#wbsUnsubscriber$.next();
      this.fetchWbsChargeCode(3);
    }
  }

  updateWbsValues(): void {
    let wbsWithArchiveDetails: WbsWithArchiveDetailsModel = {
      ...this.setDefaultArchiveValues(),
      wbsChargeCode: this.wbsChargeCode,
      wbsDescription: this.wbsDescription,
      isWBSPending: this.pendingWBSCheckboxValue,
    };

    this.wbsOrArchiveChange.emit(wbsWithArchiveDetails);
  }

  wbsPendingCheckboxChange(event: boolean): void {
    this.pendingWBSCheckboxValue = event;

    this.wbsOrArchiveChange.emit({
      ...this.setDefaultArchiveValues(),
      wbsChargeCode: undefined, // TODO: If we dont't reset we can use tempselectedcode or dont set wbscode empty on edit
      wbsDescription: undefined, // TODO: If we dont't reset we can use wbsDescription
      isWBSPending: event,
    });
  }

  onArchiveSelect(): void {
    this.showArchiveDropdown = false;
    if (this.selectedArchive !== this.archiveNotListedMsg) {
      const selectedArchiveDetails = this.archiveAPIData?.archiveDetails?.find(
        (item) => item.archiveNumber === this.selectedArchive
      );

      this.progressIndicator.show();
      this.archiveDescription = `${selectedArchiveDetails?.archiveNumber} ${selectedArchiveDetails?.archiveName}`;

      this.closeoutService
        .postGetArchiveDetails(this.selectedArchive ?? null)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: ArchiveDetailsExtendedModel) => {
            if (response) {
              const wbsWithArchiveDetails: WbsWithArchiveDetailsModel = {
                archiveNumber: selectedArchiveDetails?.archiveNumber,
                archiveName: selectedArchiveDetails?.archiveName,
                archiveID: selectedArchiveDetails?.archiveID,
                archiveFolder: selectedArchiveDetails?.archiveFolder,
                archiveFoldersArray:
                  selectedArchiveDetails?.archiveFoldersArray ?? [],
                clientName: selectedArchiveDetails?.clientName,
                clientNumber: selectedArchiveDetails?.clientNumber,
                partner: selectedArchiveDetails?.partner,
                business: selectedArchiveDetails?.business,
                archiveDescription: response.archiveDescription,
                archiveStatus: response.archiveStatus,
                wbsChargeCode: this.wbsChargeCode,
                wbsDescription: this.wbsDescription,
                isWBSPending: this.pendingWBSCheckboxValue,
              };

              this.wbsOrArchiveChange.emit(wbsWithArchiveDetails);
              this.progressIndicator.hide();
            }
          },
          error: (error: HttpErrorResponse) => {
            this.progressIndicator.hide();
            console.error('error', error);
          },
        });
    } else {
      this.archiveDescription = this.archiveNotListedMsg; //TODO: is this correct?

      this.wbsOrArchiveChange.emit({
        ...this.setDefaultArchiveValues(),
        wbsChargeCode: this.wbsChargeCode,
        wbsDescription: this.wbsDescription,
        isWBSPending: false,
        archiveNumber: this.archiveNotListedMsg,
      });
    }
  }

  fetchArchiveDropDownData(calledFrom: number = 0): void {
    if (this.wbsChargeCode) {
      this.progressIndicator.show();
      this.isFetchingArchiveData = true;
      this.archiveDropdownList = [];
      this.closeoutService
        .postSearchArchiveByWbs(this.wbsChargeCode ?? null)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: ArchiveDetailsResponseModel) => {
            if (response) {
              this.archiveAPIData = response;
              this.archiveDropdownList =
                response.archiveDetails?.map((item: ArchiveDetailsModel) => {
                  return {
                    heading: item.archiveNumber + ' ' + item.archiveName,
                    value: item.archiveNumber,
                  };
                }) ?? [];

              // TODO: Is this option alway listed ?
              this.archiveDropdownList.push({
                heading: this.archiveNotListedMsg,
                value: this.archiveNotListedMsg,
              });
              this.progressIndicator.hide();
              this.isFetchingArchiveData = false;
              this.showArchiveDropdown = true;
              this._cdr.detectChanges();
            }
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 400) {
              this.archiveDropdownList = [
                {
                  heading: this.archiveNotListedMsg,
                  value: this.archiveNotListedMsg,
                },
              ];
              this.selectedArchive = this.archiveDropdownList[0].value;
              if (calledFrom === 1) {
                this.showArchiveDropdown = true;
              } else {
                this.onArchiveSelect();
              }
              this.isFetchingArchiveData = false;
              this._cdr.detectChanges();
            }
            this.progressIndicator.hide();
            console.error('error', error, error.status);
          },
        });
    }
  }

  editArchiveDetails(): void {
    if (this.archiveDropdownList.length === 0) {
      this.fetchArchiveDropDownData(1);
    }
    this.showArchiveDropdown = true;
  }

  get showDescriptionAndArchive(): boolean {
    return !!this.wbsChargeCode && !this.showPendingWBSCheckbox;
  }

  archiveStickerHidden(): void {
    if (this.selectedArchive) {
      this.showArchiveDropdown = false;
    }
  }

  createRequestBody(): wbsChargeCodeRequestModel {
    return {
      opportunityNumber: this.dataOpportunityId,
      submissionId: this.dataSubmissionId,
      searchTerm: !!this.searchWBSText ? this.searchWBSText : '',
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
  }

  setDefaultArchiveValues(): WbsWithArchiveDetailsModel {
    // Values should be set as null but kept undefined due to model restraint.
    // These get updated in parent before the API call.
    return {
      archiveNumber: undefined,
      archiveName: undefined,
      archiveID: undefined,
      archiveFolder: undefined,
      archiveFoldersArray: [],
      clientName: undefined,
      clientNumber: undefined,
      partner: undefined,
      business: undefined,
      archiveDescription: undefined,
      archiveStatus: undefined,
    };
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next();
    this.#unsubscriber$.complete();
    this.#wbsUnsubscriber$.next();
    this.#wbsUnsubscriber$.complete();
  }
}
